import React, { useEffect } from 'react';
import './CorporateGifting.css';

const cards = [
  {
    
    stat: '100+',
    desc: 'Curated gifting combinations across Standard, Premium, and Super Premium ranges',
  },
  {
    
    stat: '3X',
    desc: 'Higher engagement when gifts are personalised compared to generic giveaways',
  },
  {
    
    stat: '70%',
    desc: 'Clients associate premium gifting with stronger brand credibility',
  },
  {
    
    stat: '4 IN 5',
    desc: 'Recipients remember the brand behind a meaningful gift',
  },
];

function CorporateGifting() {
  useEffect(() => {
    const sessionTarget = sessionStorage.getItem('scrollTarget');
    if (sessionTarget === 'why-corgif') {
      sessionStorage.removeItem('scrollTarget');
      setTimeout(() => {
        const el = document.getElementById('why-corgif');
        if (el) {
          const headerH = document.getElementById('header')?.offsetHeight || 80;
          window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - headerH - 24, behavior: 'smooth' });
        }
      }, 800);
    }
  }, []);

  return (
    <section className="cg-section" id="why-corgif">
      <div className="cg-bg-circle cg-bg-circle-1" />
      <div className="cg-bg-circle cg-bg-circle-2" />
      <div className="cg-inner">
        <h2 className="cg-heading">Why corgif's Corporate Gifting?</h2>
        <p className="cg-sub">Numbers that speak for themselves</p>
        <div className="cg-grid">
          {cards.map((c, i) => (
            <div className="cg-card" key={i}>
              <span className="cg-icon">{c.icon}</span>
              <div className="cg-stat">{c.stat}</div>
              <p className="cg-desc">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CorporateGifting;
